module.exports = __webpack_public_path__ + "float_bc_active.023cabb0.png";